import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Divider, Segment, Menu } from "semantic-ui-react";
import ReactTable from "react-table";
import request from "../../utils/request";
import matchSorter from 'match-sorter';

export const columns = [
  {
    accessor: d => (
      <Button as={Link} to={`/accounts/${d.id}/edit`} icon="edit" primary />
    ),
    id: "id",
    Header: "Action",
    filterable: false
  },
  {
    accessor: "email",
    Header: "Email",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["email"] }),
    filterAll: true
  },
  {
    accessor: "role",
    Header: "Access Level",
    filterAll: true,    
    filterMethod: (filter, rows) => {
      if (filter.value === "all") {
        return rows;
      }

      const newRows = matchSorter(rows, filter.value, { threshold: matchSorter.rankings.EQUAL, keys: ["role"] });
      return newRows;
    },
    Filter: ({ filter, onChange }) =>
      <select
        onChange={event => onChange(event.target.value)}
        style={{ width: "100%" }}
        value={filter ? filter.value : "all"}
      >
        <option value="all">Show All</option>
        <option value="admin">Adminstrator</option>
        <option value="manager">Manager</option>
      </select>
  },
  {
    accessor: "first_name",
    Header: "First Name",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["first_name"] }),
    filterAll: true
  },
  {
    accessor: "last_name",
    Header: "Last Name",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["last_name"] }),
    filterAll: true
  },
  {
    accessor: "phone_number",
    Header: "Telephone",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["phone_number"] }),
    filterAll: true
  }
];

class AccountList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMounted: false,
      isLoading: true,
      sort: [{ id: "id", desc: false }],
      data: [],
      query: "",
      limit: 20,
      page: 1,
      total: 0
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
  };
  fetchData = e => {
    this.setState({ isLoading: true });
    request
      .get(this, "api:/users", {
        sort: this.state.sort,
        q: this.state.query,
        page: this.state.page,
        limit: this.state.limit
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,
          total: Math.ceil(resp.total / this.state.limit)
        });
      });
  };
  handleChange = (e, { name, value }) => {
    this.setState({ query: value });
  };


  render() {
    const {
      data,
      limit,
      isLoading
    } = this.state;
    return (
      <Segment basic loading={isLoading}>
        <Menu secondary stackable>

          <Menu.Menu position='right'>
            <Menu.Item>
              <Button
                as={Link}
                to={"/accounts/create"}
                icon="line graph"
                content="New Account"
                primary
                fluid
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Divider hidden />
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it          
          resizable
          filterable
          defaultPageSize={limit}
          minRows={0}
        />
      </Segment>
    );
  }
}

export default AccountList;
